import { render } from "./BFormCheckbox.vue?vue&type=template&id=48fa5d26&scoped=true"
import script from "./BFormCheckbox.vue?vue&type=script&lang=js"
export * from "./BFormCheckbox.vue?vue&type=script&lang=js"

import "./BFormCheckbox.vue?vue&type=style&index=0&id=48fa5d26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fa5d26"]])

export default __exports__